import { useContext, useEffect, useState } from "react";
import { ChatbotResponse } from "./ChatbotResponse";
import { ChatbotQuestion } from "./ChatbotQuestion";
import { ChatbotStateContext } from "../utils/chatbotContext";
import { ChatCurrentMessagesArray } from "../models/chatbotModels";
import { ChatbotConversationResponseSource } from "./ChatbotConversationResponseSource";

export const ChatbotConversationList = ({ initials }: { initials: string | undefined }) => {
  const chatbotCurrentState = useContext(ChatbotStateContext);
  const [conversationMssgs, setConversationMssgs] = useState<ChatCurrentMessagesArray>([]);

  const [sourceDocument, setSourceDocument] = useState<string | undefined>(undefined);

  useEffect(() => {
    setConversationMssgs(chatbotCurrentState?.selectedConversationMssgs ? chatbotCurrentState?.selectedConversationMssgs : []);
  }, [chatbotCurrentState.selectedConversationMssgs]);

  return (
    <div className="mt-4 ml-4">
      {
        conversationMssgs.map((message, index) => (
          <div key={index} >
            {
              message.user_message ? (
                <ChatbotQuestion initials={initials} message={message} />
              ) : (
                <ChatbotResponse message={message} openSourceDocumentModal={setSourceDocument} />
              )
            }
          </div>
        ))
      }
      {sourceDocument && (
        <ChatbotConversationResponseSource
          sourceDocument={sourceDocument}
          closeModal={() => setSourceDocument(undefined)}
        />
      )}
    </div >
  );
};
